import React, { useState } from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import PropTypes from "prop-types";

const measurementOptions = [
  { display: "Neck", value: "neck" },
  { display: "Chest", value: "chest" },
  { display: "Left Arm", value: "leftArm" },
  { display: "Right Arm", value: "rightArm" },
  { display: "Waist", value: "waist" },
  { display: "Hips", value: "hips" },
  { display: "Left Thigh", value: "leftThigh" },
  { display: "Right Thigh", value: "rightThigh" },
  { display: "Left Calf", value: "leftCalf" },
  { display: "Right Calf", value: "rightCalf" },
];

const getOptionDisplay = (options) => {
  const optionsDisplay = options.map(
    (option) => measurementOptions.find((opt) => opt.value === option).display
  );

  const orderMap = measurementOptions.reduce((map, item, index) => {
    map[item.display] = index;
    return map;
  }, {});

  const sortedArray = optionsDisplay.sort((a, b) => orderMap[a] - orderMap[b]);

  return sortedArray;
};

const QuestionOptions = ({ options }) => {
  if (!options) {
    return <p className="p5">Error displaying the question</p>;
  }

  const optionsDisplayString = getOptionDisplay(options);

  return (
    <div>
      <p className="p5">
        Selected body parts:{" "}
        {optionsDisplayString.map(
          (option, index) =>
            `${option}${index !== optionsDisplayString.length - 1 ? ", " : ""}`
        )}
      </p>
    </div>
  );
};

export const CreateQuestionOptions = ({ data, setData }) => {
  const selectedOptions = data.body.options ? [...data.body.options] : [];

  const [options, setOptions] = useState(selectedOptions);

  const handleSelectOption = (value) => {
    let newOptions = [];
    if (value !== "all") {
      if (options.includes(value)) {
        newOptions = options.filter((option) => option !== value);
      } else {
        newOptions = [...options, value];
      }

      setOptions(newOptions);
    } else if (options.length === measurementOptions.length) {
      setOptions([]);
    } else {
      newOptions = measurementOptions.map((option) => option.value);

      setOptions([...newOptions]);
    }

    setData((previousState) => ({
      ...previousState,
      body: {
        ...previousState.body,
        options: [...newOptions],
      },
    }));
  };

  return (
    <div className="answer-short-body">
      <p className="p5">
        Select Body Parts for which you want your clients to fill data for:
      </p>

      <div className="answer-group-options">
        <button
          data-button-type="secondary"
          onClick={() => handleSelectOption("all")}
        >
          {options.length === measurementOptions.length
            ? "Unselect All"
            : "Select All"}
        </button>
        {measurementOptions.map((option) => (
          <div
            key={`question-measurement-${option.value}`}
            className="question-options-group"
            onClick={() => handleSelectOption(option.value)}
          >
            <SvgIcon
              src={
                options.includes(option.value)
                  ? "/img/new-icons/checked-square.svg"
                  : "/img/new-icons/unchecked-square.svg"
              }
              noFilterOnLight={options.includes(option.value)}
            />
            <p className="p5">{option.display}</p>
          </div>
        ))}
      </div>
      <div className="no-buttons"></div>
    </div>
  );
};

QuestionOptions.propTypes = {
  options: PropTypes.array,
};

CreateQuestionOptions.propTypes = {
  data: PropTypes.object,
  setData: PropTypes.any,
};

export default QuestionOptions;
